var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCommand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2C0 0.895431 0.895431 0 2 0H22C23.1046 0 24 0.895431 24 2V14.5C24 15.6046 23.1046 16.5 22 16.5H2C0.89543 16.5 0 15.6046 0 14.5V2Z",
    fill: "#717832"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4402 5.5H9.54297V10.3799H14.4402V5.5Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9087 2.55469C16.7178 2.55469 17.3761 3.21062 17.3761 4.01682C17.3761 4.82302 16.7178 5.47895 15.9087 5.47895H14.4414V4.01682C14.4414 3.21062 15.0997 2.55469 15.9087 2.55469Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62109 3.98971C6.62109 3.18064 7.27702 2.52238 8.08323 2.52238C8.88943 2.52238 9.54536 3.18064 9.54536 3.98971V5.45703H8.08323C7.27702 5.45703 6.62109 4.79877 6.62109 3.98971Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9087 13.4453C16.7178 13.4453 17.3761 12.7894 17.3761 11.9832C17.3761 11.177 16.7178 10.521 15.9087 10.521H14.4414V11.9832C14.4414 12.7894 15.0997 13.4453 15.9087 13.4453Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.62109 12.0103C6.62109 12.8194 7.27702 13.4776 8.08323 13.4776C8.88943 13.4776 9.54536 12.8194 9.54536 12.0103V10.543H8.08323C7.27702 10.543 6.62109 11.2012 6.62109 12.0103Z",
    stroke: "white",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24H0ZM24 14.5C24 15.8807 22.8807 17 21.5 17H2.5C1.11929 17 0 15.8807 0 14.5C0 15.3284 0.895431 16 2 16H22C23.1046 16 24 15.3284 24 14.5ZM0 16.5V0V16.5ZM24 0V16.5V0Z",
    fill: "#343B1B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommand);
export default __webpack_public_path__ + "static/media/command.158d5d8c78010d96874948288c283eb8.svg";
export { ForwardRef as ReactComponent };